/* main-banner-slider.js — transform-based, GPU-accelerated slider
   Drop-in replacement for the previous file. Works with existing markup:
   #mainBannerSlider > .slider__slide
*/

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('mainBannerSlider');
  if (!slider) return;

  // Defensive: ensure slides exist
  const originalSlides = Array.from(slider.querySelectorAll('.slider__slide'));
  if (!originalSlides.length) return;

  // Build a track element and move slides into it (avoids changing markup elsewhere)
  const track = document.createElement('div');
  track.className = 'hero-banner-track';
  // give minimal styling via JS to avoid FOUC
  track.style.display = 'flex';
  track.style.width = '100%';
  track.style.willChange = 'transform';
  track.style.transition = 'transform 600ms cubic-bezier(.22,.61,.36,1)';
  // Move slides into track
  originalSlides.forEach(slide => {
    slide.style.flex = '0 0 100%';
    slide.style.maxWidth = '100%';
    slide.style.boxSizing = 'border-box';
    track.appendChild(slide);
  });
  // Make slider a wrapper (overflow hidden) and insert track
  slider.style.overflow = 'hidden';
  slider.style.touchAction = 'pan-y';
  slider.innerHTML = ''; // remove old children, slides already moved to track
  slider.appendChild(track);

  // Controls & pagination: reuse existing selectors (if present)
  const paginationItems = Array.from(document.querySelectorAll('.hero-pagination-item'));
  const prevButton = document.querySelector('.hero-banner-wrapper .slider-button--prev');
  const nextButton = document.querySelector('.hero-banner-wrapper .slider-button--next');
  const slides = Array.from(track.children);
  const total = slides.length;

  // state
  let current = 0;
  let isAnimating = false;
  let autoplayTimer = null;
  const AUTOPLAY_DELAY = 5000;
  const TRANSITION_MS = 600; // match CSS transition

  // touch/drag state
  let touching = false;
  let startX = 0;
  let dragDx = 0;
  const DRAG_THRESHOLD_PX = 10;
  let lastTouchTime = 0;

  // Utility: set transform to position slide
  function setIndex(index, animate = true) {
    index = Math.max(0, Math.min(index, total - 1));
    current = index;
    if (!animate) {
      track.style.transition = 'none';
    } else {
      track.style.transition = `transform ${TRANSITION_MS}ms cubic-bezier(.22,.61,.36,1)`;
    }
    // Use percentage transform (100% per slide) so it's resolution independent
    track.style.transform = `translate3d(${-100 * current}%, 0, 0)`;
    // restore transition after next frame if we disabled it
    if (!animate) {
      requestAnimationFrame(() => { track.style.transition = `transform ${TRANSITION_MS}ms cubic-bezier(.22,.61,.36,1)`; });
    }
    // update pagination UI
    updatePagination();
  }

  // Pagination helper
  function updatePagination() {
    if (!paginationItems || !paginationItems.length) return;
    paginationItems.forEach((it, idx) => {
      it.classList.toggle('active', idx === current);
    });
  }

  // Navigation helpers
  function next() { if (isAnimating) return; setIndex((current + 1) % total, true); }
  function prev() { if (isAnimating) return; setIndex((current - 1 + total) % total, true); }

  // Buttons
  if (prevButton) prevButton.addEventListener('click', e => { e.preventDefault(); prev(); restartAutoplay(); }, { passive: true });
  if (nextButton) nextButton.addEventListener('click', e => { e.preventDefault(); next(); restartAutoplay(); }, { passive: true });

  // Pagination clicks
  if (paginationItems && paginationItems.length) {
    paginationItems.forEach((item, i) => item.addEventListener('click', () => { setIndex(i, true); restartAutoplay(); }, { passive: true }));
  }

  // Autoplay
  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      if (!touching && !isAnimating) next();
    }, AUTOPLAY_DELAY);
  }
  function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
  function restartAutoplay() { stopAutoplay(); startAutoplay(); }

  // Transition lock to prevent double-anim
  track.addEventListener('transitionstart', () => { isAnimating = true; });
  track.addEventListener('transitionend', () => { isAnimating = false; });

  // Touch / Drag handling on the slider element (not the track)
  slider.addEventListener('touchstart', onTouchStart, { passive: true });
  slider.addEventListener('mousedown', onMouseDown);

  // For touchmove we need non-passive to call preventDefault() when dragging horizontally
  slider.addEventListener('touchmove', onTouchMove, { passive: false });
  window.addEventListener('mousemove', onMouseMove, { passive: false });
  window.addEventListener('touchend', onEnd, { passive: true });
  window.addEventListener('mouseup', onEnd, { passive: true });

  function onTouchStart(e) {
    if (e.touches && e.touches.length === 1) {
      touching = true;
      startX = e.touches[0].clientX;
      dragDx = 0;
      lastTouchTime = Date.now();
      track.style.transition = 'none';
      stopAutoplay();
    }
  }
  function onMouseDown(e) {
    if (e.button !== 0) return; // left click only
    touching = true;
    startX = e.clientX;
    dragDx = 0;
    track.style.transition = 'none';
    stopAutoplay();
    e.preventDefault();
  }
  function onTouchMove(e) {
    if (!touching) return;
    const curX = (e.touches && e.touches.length) ? e.touches[0].clientX : (e.clientX || 0);
    dragDx = curX - startX;
    // if horizontal drag significant, prevent page vertical scroll
    if (Math.abs(dragDx) > 8 && e.cancelable) e.preventDefault();
    // apply pixel-level translation on top of current index
    const percent = (dragDx / slider.clientWidth) * 100;
    track.style.transform = `translate3d(${ -100 * current + percent }%, 0, 0)`;
  }
  function onMouseMove(e) {
    if (!touching) return;
    const curX = e.clientX || 0;
    dragDx = curX - startX;
    if (Math.abs(dragDx) > 8 && e.cancelable) e.preventDefault();
    const percent = (dragDx / slider.clientWidth) * 100;
    track.style.transform = `translate3d(${ -100 * current + percent }%, 0, 0)`;
  }
  function onEnd() {
    if (!touching) return;
    touching = false;
    // if drag was greater than threshold, change slide
    if (Math.abs(dragDx) > DRAG_THRESHOLD_PX) {
      if (dragDx > 0) setIndex(current - 1, true);
      else setIndex(current + 1, true);
    } else {
      // snap back
      setIndex(current, true);
    }
    restartAutoplay();
  }

  // Keyboard support
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { prev(); restartAutoplay(); }
    if (e.key === 'ArrowRight') { next(); restartAutoplay(); }
  }, { passive: true });

  // Resize handler: keep current index aligned
  let resizeTimeout = null;
  window.addEventListener('resize', () => {
    // debounce small resize flutters
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => { setIndex(current, false); }, 120);
  }, { passive: true });

  // Init position
  setIndex(0, false);
  // start autoplay
  startAutoplay();
});
